import { Icon } from '@/src/tools/icon';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { isEqual } from 'lodash';
import React from 'react';
import { Item as ItemWrapper } from 'src/components/Layouts';
import { EPositionOption } from 'src/types/common/module';
import css from './css.module.less';

const PositionOptions = (props) => {
  const { data, onChange } = props;
  const [positions, _setPosition] = React.useState(data || []);

  const setPosition = (position) => {
    _setPosition(position || []);
    onChange(position || []);
  };

  React.useEffect(() => {
    if (!isEqual(data, positions)) {
      setPosition(data || []);
    }
  }, [data]);

  const positionTip = React.useMemo(() => {
    //console.log('positions', positions);
    if (positions.length === 1) {
      if (positions.includes(EPositionOption.Center)) {
        return {
          h: getI18nFromGeneral('general.positionOptions.center_line'),
          v: getI18nFromGeneral('general.positionOptions.center_line'),
        };
      }
      if (positions.includes(EPositionOption.Left)) {
        return {
          h: getI18nFromGeneral('general.positionOptions.left'),
          v: '-',
        };
      }
      if (positions.includes(EPositionOption.Right)) {
        return {
          h: getI18nFromGeneral('general.positionOptions.right'),
          v: '-',
        };
      }
      if (positions.includes(EPositionOption.Top)) {
        return { h: '-', v: getI18nFromGeneral('general.positionOptions.top') };
      }
      if (positions.includes(EPositionOption.Bottom)) {
        return {
          h: '-',
          v: getI18nFromGeneral('general.positionOptions.bottom'),
        };
      }
    }
    if (positions.length === 2) {
      if (positions.includes(EPositionOption.Center)) {
        if (positions.includes(EPositionOption.Left)) {
          return {
            h: getI18nFromGeneral('general.positionOptions.left'),
            v: getI18nFromGeneral('general.positionOptions.center_line'),
          };
        }
        if (positions.includes(EPositionOption.Right)) {
          return {
            h: getI18nFromGeneral('general.positionOptions.right'),
            v: getI18nFromGeneral('general.positionOptions.center_line'),
          };
        }
        if (positions.includes(EPositionOption.Top)) {
          return {
            h: getI18nFromGeneral('general.positionOptions.center_line'),
            v: getI18nFromGeneral('general.positionOptions.top'),
          };
        }
        if (positions.includes(EPositionOption.Bottom)) {
          return {
            h: getI18nFromGeneral('general.positionOptions.center_line'),
            v: getI18nFromGeneral('general.positionOptions.bottom'),
          };
        }
      } else {
        const dict = {
          [EPositionOption.Bottom]: getI18nFromGeneral(
            'general.positionOptions.bottom',
          ),
          [EPositionOption.Top]: getI18nFromGeneral(
            'general.positionOptions.top',
          ),
          [EPositionOption.Left]: getI18nFromGeneral(
            'general.positionOptions.left',
          ),
          [EPositionOption.Right]: getI18nFromGeneral(
            'general.positionOptions.right',
          ),
        };
        const re = {
          h: '-',
          v: '-',
        };
        const [pos1, pos2] = positions;
        if ([EPositionOption.Bottom, EPositionOption.Top].includes(pos1)) {
          re.v = dict[pos1];
        }
        if ([EPositionOption.Left, EPositionOption.Right].includes(pos1)) {
          re.h = dict[pos1];
        }
        if ([EPositionOption.Bottom, EPositionOption.Top].includes(pos2)) {
          re.v = dict[pos2];
        }
        if ([EPositionOption.Left, EPositionOption.Right].includes(pos2)) {
          re.h = dict[pos2];
        }
        return re;
      }
    }
    return { h: '-', v: '-' };
  }, [positions]);
  const classGenerate = (position) => {
    if (positions.includes(position)) {
      return `${css.icon} ${css.selectedIcon}`;
    }
    return `${css.icon}`;
  };
  const isMidSelect = positions.includes(EPositionOption.Center);
  //   const isVerticalSelect =
  //     positions.includes(EPositionOption.Bottom) ||
  //     positions.includes(EPositionOption.Top);

  //   const isHorizontalSelect =
  //     positions.includes(EPositionOption.Left) ||
  //     positions.includes(EPositionOption.Right);

  const isPositionSelected = (position) => {
    return !!positions.find((i) => i === position);
  };

  const isOppositeSelected = (position) => {
    if (position === EPositionOption.Center) {
      return false;
    }
    if (position === EPositionOption.Left) {
      return !!positions.find((i) => i === EPositionOption.Right);
    }
    if (position === EPositionOption.Right) {
      return !!positions.find((i) => i === EPositionOption.Left);
    }
    if (position === EPositionOption.Top) {
      return !!positions.find((i) => i === EPositionOption.Bottom);
    }
    if (position === EPositionOption.Bottom) {
      return !!positions.find((i) => i === EPositionOption.Top);
    }
  };

  const getOpposite = (position) => {
    if (position === EPositionOption.Left) {
      return EPositionOption.Right;
    }
    if (position === EPositionOption.Right) {
      return EPositionOption.Left;
    }
    if (position === EPositionOption.Top) {
      return EPositionOption.Bottom;
    }
    if (position === EPositionOption.Bottom) {
      return EPositionOption.Top;
    }
    return EPositionOption.Center;
  };

  const handleOnClickMid = () => {
    if (isMidSelect) {
      // const f = positions.filter((i) => i !== EPositionOption.Center);
      // setPosition(f);
    } else {
      setPosition([EPositionOption.Center]);
    }
  };

  const handleOnClickOther = (position) => {
    const _isPositionSelected = isPositionSelected(position);
    if (_isPositionSelected) {
      // console.log(1);
      if (isMidSelect) {
        const f = positions.filter((i) => i !== position);
        setPosition([...f]);
        return;
      } else {
        const f = positions.filter((i) => i !== position);
        setPosition([EPositionOption.Center, ...f]);
        return;
      }
    }
    const _isOppositeSelected = isOppositeSelected(position);
    if (isMidSelect) {
      const rest =
        positions.length > 1
          ? positions.filter((i) => i !== EPositionOption.Center)
          : positions;

      if (_isOppositeSelected) {
        const _f = [position, EPositionOption.Center];

        setPosition(_f);
      } else {
        const f = [...rest, position];

        setPosition(f);
      }
    } else {
      if (_isOppositeSelected) {
        const opposite = getOpposite(position);
        const f = positions.filter((i) => i !== opposite);
        const _f = [...f, position];

        setPosition(_f);
      } else {
        const f = [...(positions || []), position];

        setPosition(f);
      }
      //const
    }
  };
  //console.log(positions);

  return (
    <div className={css.container}>
      <div className={css.imagePart}>
        <div className={css.selector}>
          <div className={css.topBottomLine}>
            <Icon
              type='icontop4'
              className={classGenerate(EPositionOption.Top)}
              onClick={(e) => handleOnClickOther(EPositionOption.Top)}
            />
          </div>
          <div className={css.midLine}>
            <Icon
              type='iconleft3'
              className={classGenerate(EPositionOption.Left)}
              onClick={(e) => handleOnClickOther(EPositionOption.Left)}
              //onClick={(e) => e.stopPropagation()}
            />
            <Icon
              type='iconcentre'
              className={classGenerate(EPositionOption.Center)}
              onClick={handleOnClickMid}
              //onClick={(e) => e.stopPropagation()}
            />
            <Icon
              type='iconright3'
              className={classGenerate(EPositionOption.Right)}
              onClick={(e) => handleOnClickOther(EPositionOption.Right)}
              //onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className={css.topBottomLine}>
            <Icon
              type='iconbottom2'
              className={classGenerate(EPositionOption.Bottom)}
              onClick={(e) => handleOnClickOther(EPositionOption.Bottom)}
              //onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      </div>
      <div className={css.explanationPart}>
        <ItemWrapper
          title={getI18nFromGeneral('general.positionOptions.horizontal')}
          size='small'>
          {positionTip.h}
        </ItemWrapper>
        <ItemWrapper
          title={getI18nFromGeneral('general.positionOptions.vertical')}
          size='small'>
          {positionTip.v}
        </ItemWrapper>
      </div>
    </div>
  );
};
export default PositionOptions;
